<style scoped lang="sass">
.title-line
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 0.5rem
  .title
    font-weight: 700
  .custom-link
    font-size: 0.6rem
</style>
<template>
  <div>
    <div class="title-line">
      <div class="title">Customize Your Pool</div>
      <a href="#" @click.prevent="advanced = true" v-if="!advanced" class="custom-link">ADVANCED</a>
      <a href="#" @click.prevent="setAsStandard" v-if="advanced" class="custom-link">SET AS STANDARD</a>
    </div>
    <form @submit.prevent="submit">
      <div v-if="!advanced">
        Everyone chooses one player from each of 5 brackets. Various point values are assigned based on how players finish. Low rounds on each day get a point and if all picks make the cut, another point.
        <br />
        <br />
      </div>
      <div v-else>
        <div class="input-group">
          <label>PICKS STYLE</label>
          <div v-if="errors.poolStyleId">{{errors.poolStyleId}}</div>
          <pinhigh-select
            :options="poolStyleOptions"
            v-model="poolStyleId"
            ></pinhigh-select>
        </div>
        <component
            :is="selectedPoolStyle.component"
            :errors="errors"></component>
        <component
            :is="selectedScoringMethod.component"
            :errors="errors"></component>
      </div>
      <div>
        <input type="submit" value="Next: Invite Friends" class="button positive">
      </div>
    </form>
  </div>
</template>
<script>
import Vuex            from 'vuex';

import BracketPicks    from './bracket-picks.vue';
import IndividualPicks from './individual-picks.vue';
import AssignValues    from './assign-values.vue';

export default {
  name: 'Configure',
  props: {
    goToStep: {
      type: Function,
      required: true
    }
  },
  components: {
    BracketPicks,
    IndividualPicks,
    AssignValues
  },
  data() {
    return {
      errors: {},
      advanced: false,
      poolStyles: [
        {
          name: 'Bracket Picks',
          description: 'Choose one player from each bracket',
          component: 'bracket-picks',
        },
        {
          name: 'Individual Picks',
          description: 'Choose players from the entire field',
          component: 'individual-picks',
        }
      ],
      scoringMethods: [
        {
          name: 'Assign Values',
          description: 'Assign point values based on finishing place',
          component: 'assign-values',
        }
      ]
    };
  },
  created() {
    if (!this.isDefaultConfig) {
      this.advanced = true;
    }
  },
  computed: {
    ...Vuex.mapGetters('poolForm', ['pool', 'isDefaultConfig', 'isPoolNew']),
    poolStyleId: {
      get(){ return this.pool.pool_style_id; },
      set(value){ this.$store.dispatch('poolForm/setPoolStyleId', value); }
    },
    scoringMethodId: {
      get(){ return this.pool.scoring_method_id; },
      set(value){ this.$store.dispatch('poolForm/setScoringMethodId', value); }
    },
    poolStyleOptions() {
      return this.poolStyles.map(({name}) => ({value: name, label: name}));
    },
    selectedPoolStyle() {
      return this.poolStyles.find(({name}) => name === this.poolStyleId);
    },
    selectedScoringMethod() {
      return this.scoringMethods.find(({name}) => name === this.scoringMethodId);
    }
  },
  methods: {
    setPoolValue(key) {
      return value => this[key] = value;
    },
    setAsStandard() {
      this.advanced = false;
      this.$store.dispatch('poolForm/resetPoolStyle');
      this.$store.dispatch('poolForm/resetScoringMethod');
    },
    submit() {
      this.validateForm();
      if (_.values(this.errors).every(v => !v)) {
        this.goToStep({step: 'invite'});
      }
    },
    validateForm() {
      this.errors = {};
      if (!this.poolStyleId) {
        this.errors.poolStyleId = 'You must select a pick style';
      }
      if (!this.scoringMethodId) {
        this.errors.scoringMethodId = 'You must select a scoring method';
      }
    }
  }
};
</script>
